import { Button, Dialog, NAME_SOUND_HOVER, useGameSounds, useTranslate } from "@educaplay/core";
import classes from './ConfirmationDialog.module.scss';
import { useRef } from "react";
import { useEffect } from "react";

export function ConfirmationDialog(props) {
    const { open, onClose, playpausehandler } = props;
    const t = useTranslate();
    const gameSound = useGameSounds();
    const buttonRef = useRef();  

    useEffect(() => {
        if(!open) return;
        setTimeout(() => buttonRef.current.focus());
    },[buttonRef,open])

    return (
        <Dialog open={open} onClose={onClose} variant="explanation" animated>
            <div className={classes.feedbackContainer} onClick={(e) => e.stopPropagation()}>
                <div className={classes.feedbackHeader}>{t('specific.passquestionmsg')}</div>
                <div className={classes.feedbackMsgContainer}>
                    <div className={classes.feedbackMsg}>
                        {t('specific.passquestiondesc')}
                    </div>
                    <div className={classes.buttonsFeedbackContainer}>

                        <Button onClick={(e) => {
                            onClose(e);
                            playpausehandler({ acceptDialog: true });
                        }} className={classes.btnaspect}
                            onMouseEnter={() => gameSound.play(NAME_SOUND_HOVER)}
                        >{t('common.settings.accept')}</Button>
                        <Button ref={buttonRef} onClick={onClose} className={classes.btnaspect} onMouseEnter={() => gameSound.play(NAME_SOUND_HOVER)} >{t('common.settings.cancel')}</Button>
                    </div>
                </div>
            </div>
        </Dialog>
    )
}